module.exports = __webpack_public_path__ + "static/gm-32-ab2f2a26bf11e86682004edc27f0114f.jpg";